import App from "./App.svelte";

const el = document.querySelector("#nc-tg4");

const app = new App({
  target: el,
});

export default app;
